export type FeEstadoUi = 'pendiente' | 'aceptada' | 'rechazada' | 'error';

export function normalizeFeEstado(raw?: string | null): FeEstadoUi | null {
  const s = String(raw || '')
    .toLowerCase()
    .trim();
  if (s === 'aceptada') return 'aceptada';
  if (s === 'pendiente') return 'pendiente';
  if (s === 'rechazada') return 'rechazada';
  if (s === 'error') return 'error';
  return null;
}

export function feEstadoBadge(
  estado?: string | null
): { label: string; className: string } | null {
  const e = normalizeFeEstado(estado);
  if (!e) return null;
  if (e === 'aceptada') {
    return { label: 'FE aceptada', className: 'bg-emerald-100 text-emerald-800' };
  }
  if (e === 'pendiente') {
    return { label: 'FE pendiente', className: 'bg-amber-100 text-amber-800' };
  }
  if (e === 'rechazada') {
    return { label: 'FE rechazada', className: 'bg-red-100 text-red-800' };
  }
  return { label: 'FE error', className: 'bg-red-100 text-red-800' };
}

export function truncateCufe(cufe: string, keep = 10): string {
  const t = cufe.trim();
  if (t.length <= keep * 2 + 1) return t;
  return `${t.slice(0, keep)}…${t.slice(-keep)}`;
}
